import React from 'react'
import PropTypes from 'prop-types'

import { backgroundGrey } from '../../../../../../../../styles/const/colors'

const FadedOutCell = ({ date, shouldFadeOut }) => {
  return (
    <div
      style={{
        backgroundColor: shouldFadeOut ? backgroundGrey : undefined,
        display: 'inline-block',
        width: '100%'
      }}
    >
      {date.getDate()}
    </div>
  )
}

FadedOutCell.propTypes = {
  date: PropTypes.instanceOf(Date).isRequired,
  shouldFadeOut: PropTypes.bool.isRequired
}

export default React.memo(FadedOutCell)
